import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import { CaseStudiesContent, CaseStudyContent } from "@/components/case-study-content";
import { caseStudiesIndexMeta, findCaseStudy, type CaseStudy } from "@/data/case-studies";
import { useCaseStudySeo } from "@/hooks/use-case-study-seo";
import NotFound from "@/pages/not-found";

export default function CaseStudiesPage() {
  useCaseStudySeo(caseStudiesIndexMeta);
  return (
    <div className="flex flex-col min-h-[100dvh] bg-background">
      <Header />
      <main className="flex-1"><CaseStudiesContent /></main>
      <Footer />
    </div>
  );
}

export function CaseStudyPage({ slug }: { slug: string }) {
  const study = findCaseStudy(slug);
  if (!study) return <NotFound />;
  return <CaseStudyView study={study} />;
}

function CaseStudyView({ study }: { study: CaseStudy }) {
  useCaseStudySeo(study);
  return (
    <div className="flex flex-col min-h-[100dvh] bg-background">
      <Header />
      <main className="flex-1"><CaseStudyContent study={study} /></main>
      <Footer />
    </div>
  );
}
